import { useQueryClient } from "@tanstack/react-query"

import { invalidateDocumentProject, invalidateDocumentsList } from "@l2r-front/l2r-app-doc"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { equipmentQueryKeys } from "../queries/equipment/queryKeys"

import { useEquipmentMutation } from "./useEquipmentMutation"

export function useEquipmentUpdate(
    equipmentId,
    queryParameters,
    config = {},
) {
    const url = `equipments/${equipmentId}/`
    const queryClient = useQueryClient()

    return useEquipmentMutation(
        url,
        axiosInstance.patch,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.feature(equipmentId) })
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.project() })
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.layer() })
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.stats_categories() })
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.stats_conditions() })
                config.onSuccess?.(data)
            },
        },
    )
}

export function useEquipmentUpdateDocument(
    equipmentId,
    queryParameters,
    config = {},
) {
    const url = `equipments/${equipmentId}/`
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()

    const axiosFn = (url, values) => {
        const formData = new FormData()
        Object.entries(values).forEach(([key, value]) => {
            if (key === "document") {
                Object.entries(values[key]).forEach(([docKey, docValue]) => {
                    if (Array.isArray(docValue)) {
                        formData.append(`${key}.${docKey}`, JSON.stringify(docValue))
                    } else {
                        formData.append(`${key}.${docKey}`, docValue)
                    }
                })
            } else {
                formData.append(key, value)
            }
        })

        const headers = values.document ? { "Content-Type": "multipart/form-data" } : {}

        return axiosInstance.patch(url, formData, {
            headers: headers,
        })
    }

    return useEquipmentMutation(
        url,
        axiosFn,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: equipmentQueryKeys.feature(equipmentId) })
                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)
                config.onSuccess?.(data)
            },
        },
    )
}